var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94254 6.99828C10.2196 6.6904 10.6938 6.66544 11.0017 6.94254L15.1758 10.6992C15.9483 11.3944 15.9483 12.6056 15.1758 13.3008L11.0017 17.0575C10.6938 17.3346 10.2196 17.3096 9.94254 17.0017C9.66544 16.6938 9.6904 16.2196 9.99828 15.9425L14.1724 12.1858C14.2827 12.0865 14.2827 11.9135 14.1724 11.8142L9.99828 8.05748C9.6904 7.78038 9.66544 7.30617 9.94254 6.99828Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight3);
export default __webpack_public_path__ + "static/media/arrow-right-3.9977736e.svg";
export { ForwardRef as ReactComponent };